import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0 10px 5px 0 rgba(11, 11, 11, 0.2)',
    padding: '2rem',
    marginTop: '2rem',

    [theme.breakpoints.down('lg')]: {
      width: '75%',
      padding: '1rem 2rem'
    }
  },

  enter: {
    width: '60%',
    margin: 'auto'
  },

  boxBG: {
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '-1',
    opacity: '0.1',
    borderRadius: '1rem',
    border: '0.125rem solid #F1F1F1',
    boxShadow: '0 0.705rem 0.705rem 0 rgba(66, 81, 89, 0.2)',
    width: 'calc(100% - 4px)',
    height: 'calc(100% - 4px)',
    backgroundColor: 'white'
  },

  envContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',

    [theme.breakpoints.down('lg')]: {
      maxHeight: 350,
      overflowY: 'auto'
    }
  },

  error: {
    margin: '0.5rem auto',
    borderRadius: '200rem',
    width: 'fit-content',
    padding: '0.8rem 2rem',
    background: theme.palette.loginError.bg,
    fontSize: theme.size.sm,
    textAlign: 'center',
    color: theme.palette.loginError.text
  },
  icon: {
    width: '1rem',
    height: '1rem'
  }
}))

export default useStyles
